import routerOptions0 from "/var/lib/jenkins/workspace/taro-trip-production/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@22.5.1_eslint@8.57.0_ioredis@5.4.1_magica_d1989d2994b57124da3abcbd28e11084/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}